module.exports = __webpack_public_path__ + "static/media/knowledge.d2ad53a4.svg";